import { render, staticRenderFns } from "./ImportScreen.vue?vue&type=template&id=2ef5ff81&"
import script from "./ImportScreen.vue?vue&type=script&lang=js&"
export * from "./ImportScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports